<button type="button" class="no-button" (click)="refreshRecords()">
    <img [src]="cvaUI_url+ '/assets/icons/refresh.svg'" title="Refresh" alt="Refresh Icon" class="refresh-icon pointer"
        [class.rotated]="isRefreshing">
</button>